import React, { useState, useEffect, useMemo } from 'react';
import { Link, NavLink} from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Media } from '../../Object';
import Button from '../../Object';
import { useDocumentLoadCompleted } from '../../Hooks';

const Nav = (props) => {
  const [pages, setPages] = useState([]); // 固定ページ情報
  const isLoaded = useDocumentLoadCompleted();

  const linkClass = {
    header: {
      active: "p-nav__link p-nav__link--active c-text__med c-text--bold c-text--white",
      anActive: "p-nav__link c-text__med c-text--bold c-text--white",
      contact: "c-text__med c-text--bold p-nav__link--contact c-text--white",
    },
    footer: {
      active: "p-nav__link--footer c-text__normal c-text--bold c-text--en",
      anActive: "p-nav__link--footer c-text__normal c-text--bold c-text--en",
      contact: "c-text__med c-text--bold p-nav__link--contact c-text--en",
    },
  };

  const position = props.position;

  const subLink = {
    service: [
      ["/service/", "・事業内容"],
      ["/fix/", "・修正・編集でお困りの方へ"],
    ],
    voice: [
      ["/voice/", "・お客様の声"],
      ["/voice/#faq", "・FAQ"],
    ],
  };

  const viewMenu = [
    "home",
    "about",
    "service",
    "posts",
    "works",
    "voice",
    "company",
    "fix",
    "recruit",
    "contactus",
  ];

  useEffect(() => {
    fetch(
      `${tmp_path.site_url}/wp-json/wp/v2/pages?per_page=100`
    )
      .then((response) => response.json())
      .then((data) => {
        data = data.reverse();
        setPages(data);
      })
  }, []);

  const Scroll = (props) => {
    setTimeout(() => {
      let margin = 126;
      const rect = props.getBoundingClientRect();
      const target = rect.top - margin + window.pageYOffset;
      scrollTo({
        top: target,
        left: 0,
        behavior: "smooth",
      });
    }, 800);
  };

  const toLink = (link) => {
    if (link == "home") {
      return "/";
    } else {
      return `/${link}/`;
    }
  };

  const InnerItems = (props) => {
    if (props.slug in subLink) {
      return (
        <>
          {subLink[props.slug].map(link => 
            <NavLink
              key={link[0]}
              to={link[0]}
              className="c-text__med c-text--white"
              data-state={
                props.state ? props.state : props.active ? "active" : ""
              }
            >
              {link[1]}
            </NavLink>
          )}
        </>
      );
    }
  };
  
  let Items = pages.map((page, key) => {
    if (
      viewMenu.indexOf(page.slug) !== -1 &&
      props.remove.indexOf(page.slug) == -1
    ) {
      let link = toLink(page.slug);
      if (link.indexOf("#") !== -1) {
        return (
          <li id={page.slug} className="p-nav__items" key={key}>
            <HashLink
              to={toLink(page.slug)}
              className={linkClass[position].anActive}
              data-state={
                props.state ? props.state : props.active ? "active" : ""
              }
              scroll={(el) => Scroll(el)}
            >
              {page.title.rendered}
            </HashLink>
          </li>
        );
      } else {
        return (
          <li id={page.slug} className="p-nav__items" key={key}>
            <NavLink
              to={toLink(page.slug)}
              className={({ isActive }) =>
                isActive
                  ? linkClass[position].active
                  : linkClass[position].anActive
              }
              data-state={
                props.state ? props.state : props.active ? "active" : ""
              }
            >
              {page.title.rendered}
            </NavLink>
            {position == 'footer' &&
              <InnerItems slug={page.slug}></InnerItems>
            }
          </li>
        );
      }
    }
  });
  
  const ItemsMemo = useMemo(() => Items, [pages]);

  let HeaderContact = () => {
    if (props.position == "header") {
      return (
        <>
          <Link className={`${linkClass[position].contact}`} to="/contact/">
            <Media
              class="p-nav__img--icon"
              src="common/icon-mail"
              alt="mail"
            ></Media>
            Contact
          </Link>
          <a
            className={`${linkClass[position].contact} p-nav__link--contact--phone sp`}
            href="tel:0789280200"
          >
            <Media
              class="p-nav__img--icon"
              src="common/icon-phone"
              alt="phone"
            ></Media>
            078-928-0200
          </a>
        </>
      );
    }
  };

  return (
    <>
      <div
        className={`p-nav__wrap ${props.open ? "p-nav__wrap--open" : ""}`}
        data-state={props.position}
      >
        <ul
          className={`p-nav__list ${props.open ? "p-nav__list--open" : ""}`}
          data-state={props.position}
        >
          {/* { props.position == 'header' && (
            <i className="p-nav__list--button" data-state={props.open} onClick={() => props.toggleOpen() }></i>
          )} */}
          {ItemsMemo}
        </ul>
      </div>
    </>
  );
};

export default Nav;
